import { RouteHttpVerb } from "@devowl-wp/utils";
const locationRestPluginFeedbackPost = {
    path: "/feedback/:slug",
    method: RouteHttpVerb.POST
};
export { locationRestPluginFeedbackPost };
